import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useRef, type ReactNode } from 'react';

type Props = { children: ReactNode };

function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        retry: 1,
        refetchOnWindowFocus: false
      },
      mutations: {
        retry: 0
      }
    }
  });
}

export default function AppQueryClientProvider({ children }: Readonly<Props>) {
  const clientRef = useRef<QueryClient | null>(null);
  clientRef.current ??= createQueryClient();

  return <QueryClientProvider client={clientRef.current}>{children}</QueryClientProvider>;
}
